import { render, staticRenderFns } from "./screen-builder.vue?vue&type=template&id=343ecc77&scoped=true"
import script from "./screen-builder.vue?vue&type=script&lang=js"
export * from "./screen-builder.vue?vue&type=script&lang=js"
import style0 from "./screen-builder.vue?vue&type=style&index=0&id=343ecc77&prod&scoped=true&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "343ecc77",
  null
  
)

export default component.exports